/**
 * usePermissions hook
 *
 * Provides permission checking functions based on user roles and system privileges.
 * Implements hierarchical permission resolution: System Admin > Programme Roles > Project Roles > Default.
 */

import { useAuth } from '../contexts/AuthContext';
import * as permissions from '../utils/permissions';

export interface UsePermissionsReturn {
  canEditProject: (projectId: string, programmeId?: string) => boolean;
  canViewProject: (projectId: string, programmeId?: string) => boolean;
  canEditProgramme: (programmeId: string) => boolean;
  canViewProgramme: (programmeId: string) => boolean;
  canManageProgrammes: boolean;
  isPortfolioManager: boolean;
}

export const usePermissions = (): UsePermissionsReturn => {
  const { user } = useAuth();

  return {
    canEditProject: (projectId, programmeId) => permissions.canEditProject(user, projectId, programmeId),
    canViewProject: (projectId, programmeId) => permissions.canViewProject(user, projectId, programmeId),
    canEditProgramme: (programmeId) => permissions.canEditProgramme(user, programmeId),
    canViewProgramme: (programmeId) => permissions.canViewProgramme(user, programmeId),
    canManageProgrammes: permissions.canManageProgrammes(user),
    isPortfolioManager: permissions.isPortfolioManager(user),
  };
};